//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.OffsetDataBuilder.js";
import "../CAM/CAM.RoundPointBuilder.js";
let d=[[[0,"LockAxis",1,0],[0,"LockPlane",1,0],[0,"LockPos",1,0],[1,"OffsetData",0,"CAM.OffsetDataBuilder",0],[0,"Point",1,"Point",0],[1,"RoundPoint",0,"CAM.RoundPointBuilder",0]],[],[]];
SPLM.CAM.RotaryPolarMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.RotaryPolarMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.RotaryPolarMoveBuilder.LockAxisDirection = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.CAM.RotaryPolarMoveBuilder.LockPlaneType = Object.freeze({
    "Xy" : "Xy", "Yz" : "Yz", "Zx" : "Zx"});

export default SPLM;